var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 800,
    viewBox: "0 0 600 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447.188 676.119V675.126H154.305V676.119H137.83L41.0391 800H112.358L133.772 768.386H467.106L488.516 800H559.858L463.061 676.119H447.188ZM154.439 737.887L176.295 705.625H424.595L446.452 737.887H154.439Z",
    fill: "#062134"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300.445 0C76.6125 0 12 81.2219 12 143.223V547.288C12 601.811 56.2031 646.062 110.787 646.062H490.108C544.705 646.062 588.884 601.811 588.884 547.288V143.223C588.884 81.2219 524.284 0 300.445 0ZM195.897 89.0422H404.983C418.87 89.0422 430.148 100.308 430.148 114.195C430.148 128.12 418.87 139.373 404.983 139.373H195.897C182.008 139.373 170.744 128.12 170.744 114.195C170.742 100.308 182.006 89.0422 195.897 89.0422ZM150.872 560.061C133.539 560.061 119.491 546.013 119.491 528.68C119.491 511.345 133.539 497.298 150.872 497.298C168.205 497.298 182.253 511.345 182.253 528.68C182.252 546.013 168.205 560.061 150.872 560.061ZM278.478 373.872H110.959V220.647H278.478V373.872ZM450.031 560.061C432.697 560.061 418.65 546.013 418.65 528.68C418.65 511.345 432.697 497.298 450.031 497.298C467.362 497.298 481.412 511.345 481.412 528.68C481.412 546.013 467.362 560.061 450.031 560.061ZM497.391 373.872H322.412V220.647H497.391V373.872Z",
    fill: "#062134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTrain);
export default __webpack_public_path__ + "static/media/ico_train.ef1b04825310d3351d9140a51e8662a9.svg";
export { ForwardRef as ReactComponent };